import React, { } from 'react';
import { Pressable, View, Text, Image } from 'react-native';

import Modal from 'react-native-modal';

import { getImagePath } from '../services/CommonUtils';

import AppTheme from '../../AppTheme';
import AppStyles from '../../AppStyles';
import TextStyle from '../../TextStyle';

const PhotoCaptureModel = (props) => {
    const showPhotoCaptureModal = props.showPhotoCaptureModal
    const closeModal = props.closeModal
    const capturePhotoAction = props.capturePhotoAction
    return <Modal key={'photo capture modal'}
        isVisible={showPhotoCaptureModal} hasBackdrop={true}
        deviceHeight={AppTheme.modalHeight}
        backdropOpacity={AppTheme.modalBackdropOpacity}
        animationOutTiming={AppTheme.modalAnimationDuration}
        style={[AppStyles.alignCenter, { marginBottom: 0 }]}
        onBackdropPress={() => closeModal()}>
        <View style={[AppStyles.bottomFix, AppStyles.topBorderView,
        AppStyles.flexRowCenter, {
            width: AppTheme.appWidth, padding: 16, margin: "auto"
        }]}><Pressable onPress={() => {
            closeModal(); capturePhotoAction('camera')
        }} style={[AppStyles.borderView, AppStyles.bgWhite, AppStyles.alignCenter,
        { height: 120, width: AppTheme.appWidth / 2 - 24 }]} onLongPress={() => { console.log('### long press') }}>
                <Image style={{ height: 24, width: 28 }}
                    source={{ uri: getImagePath('/images/icons/camera.svg') }} />
                <Text style={[TextStyle.text14b,
                { marginTop: 6 }]}>Camera</Text>
            </Pressable>
            <View style={{ width: 16 }} />
            <Pressable onPress={() => {
                closeModal(); capturePhotoAction('gallary')
            }} style={[AppStyles.borderView, AppStyles.bgWhite, AppStyles.alignCenter,
            { height: 120, width: AppTheme.appWidth / 2 - 24 }]} onLongPress={() => { console.log('### long press') }}>
                <Image style={{ height: 25, width: 28 }}
                    source={{ uri: getImagePath('/images/icons/gallery.svg') }} />
                <Text style={[TextStyle.text14b,
                { marginTop: 6 }]}>Gallery</Text>
            </Pressable>
        </View>
    </Modal>
}

export default PhotoCaptureModel